import React, { useState, useEffect } from "react";
import { Container, Col, Row, Form } from "react-bootstrap";
import API_DOMAIN from "../config/config";
import { FaMagnifyingGlass } from "react-icons/fa6";
import { TableUI } from "../components/Tables";
import { TextInputForm } from "../components/Forms";

import { ClickButton } from "../components/Buttons";
import { useNavigate } from "react-router-dom";


const LocationTablehead = [
  "No",
  "Date",
  "Attendance Status",
  "Full Day Absent",
  "Total Wages",
  "Action",
];

const Attendance = () => {
  const navigate = useNavigate();

  const [attendanceData, setAttendanceData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const [searchText, setSearchText] = useState("");


  useEffect(() => {
    fetchData();
  }, [searchText, currentPage]);

  const fetchData = async () => {
    try {
      const response = await fetch(`${API_DOMAIN}/attendance.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          action: "listAttendance",
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const responseData = await response.json();
      console.log(responseData);

      if (responseData.head.code === 200) {
    
        const transformedData = responseData.body.attendance.map(
          (attendance, index) => {
            // Calculate presents and absents based on half-days
            let fullDayPresents = 0;
            let halfDayPresents = 0;
            let fullDayAbsents = 0;
            
            attendance.data.forEach((item) => {
              const firstHalf = item.firstHalf || item.status || "absent";
              const secondHalf = item.secondHalf || item.status || "absent";
              
              if (firstHalf === "present" && secondHalf === "present") {
                fullDayPresents++;
              } else if ((firstHalf === "present" && secondHalf === "absent") || 
                         (firstHalf === "absent" && secondHalf === "present")) {
                halfDayPresents++;
              } else if (firstHalf === "absent" && secondHalf === "absent") {
                fullDayAbsents++;
              }
            });
            
            const totalWages = attendance.data.reduce((sum, item) => sum + (item.wages || 0), 0);
            const formattedDate = formatDate(attendance.entry_date);
            const profiledata = attendance.data;

            return {
              attendance_id: attendance.attendance_id,
              key: (index + 1).toString(),
              entry_date: formattedDate,
              presents: `${fullDayPresents} Full + ${halfDayPresents} Half`,
              absents: fullDayAbsents,
              total_wages: totalWages,
              data: profiledata,
            };
          }
        );

        // Filter the data based on the searchText
        const filteredData = transformedData.filter((item) =>
          item.entry_date.toLowerCase().includes(searchText.toLowerCase())
        );

        setAttendanceData(filteredData); // Update the state with filtered data
      } else {
        throw new Error(responseData.message || "Unknown error");
      }
    } catch (error) {
    }
  };
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = String(date.getFullYear()).slice(-2);
    return `${day}/${month}/${year}`;
  };

  const handleSearch = (value) => {
    setSearchText(value.trim()); 
    setCurrentPage(1);
  };


  return (
    <div style={{ cursor: "pointer" }}>
      <Container fluid>
        <Row>
          <Col lg="12" className="py-3">
            <div className="main my-3">
              <Row className="mx-2">
                <Col lg="12" md="12" xs="12" className="align-self-center">
                 
                   <h4 className="mb-0 fw-bold text-primary">Attendance</h4>
                </Col>
                <Col lg="3">
                  <div className=" mx-2">
                    {/* <Buttons lable={<>Filter</>} onClick={showFilter} /> */}
                    <TextInputForm
                      placeholder={"Search by date"}
                      onChange={(e) => handleSearch(e.target.value)}
                      prefix_icon={<FaMagnifyingGlass />}
                      labelname={"Search"}
                    >
                      {" "}
                    </TextInputForm>
                  </div>
                </Col>
                <Col
                  lg="9"
                  className="d-flex align-item-baseline justify-content-end"
                >
                  <div className="text-end">
                    <ClickButton
                      label={<>Add New</>}
                      onClick={() => navigate("/console/attendance/create")}
                    />
                  </div>
                </Col>
              </Row>
              <div className="py-2 ">
                <TableUI
                  headers={LocationTablehead}
                  body={attendanceData}
                  pageview={"yes"}
                  type="attendance"
                />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Attendance;

